import { defineComponent as _defineComponent } from 'vue'
import { BookTalkQuestion, DifficultWord, SetBookTalkBody } from '@ilteducation/exercise-service-types';
import { setBookTalkQuestions } from '@/data-provider/bookTalk';
import ImportButton from '@/components/buttons/ImportButton.vue';
import eventBus from '@/foundations/services/eventBus';


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const questionsSheetBookIdColumnHeader = 'Book ID';
const questionsSheetPageStartColumnHeader = 'Pages Start';
const questionsSheetPageEndColumnHeader = 'Pages End';
const questionsSheetQuestionColumnHeader = 'Question';

const wordsSheetBookIdColumnHeader = 'Book ID';
const wordsSheetWordColumnHeader = 'Word';
const wordsSheetDefinitionColumnHeader = 'Description';

const instructionsSheetBookIdColumnHeader = 'Book ID';
const instructionsSheetInstructionsColumnHeader = 'Instructions';

const uploadBookTalkQuestions = async (entries: any[]) => {
  const groupedQuestions = new Map<string, SetBookTalkBody>();

  entries.forEach((entry) => {
    const bookId = entry[questionsSheetBookIdColumnHeader];
    const pageStart = entry[questionsSheetPageStartColumnHeader] || 0;
    const pageEnd = entry[questionsSheetPageEndColumnHeader] || 0;
    const questionCell: string = entry[questionsSheetQuestionColumnHeader]
      ? entry[questionsSheetQuestionColumnHeader].trim()
      : '';

    const parsedQuestions: BookTalkQuestion[] = questionCell
      ? [
          {
            question: questionCell,
            referencePageRange: {
              start: parseInt(pageStart, 10),
              end: parseInt(pageEnd, 10),
            },
          },
        ]
      : [];

    if (groupedQuestions.has(bookId)) {
      const existingQuestions = groupedQuestions.get(bookId);
      if (existingQuestions) {
        existingQuestions.questions?.push(...parsedQuestions);
      }
    } else {
      groupedQuestions.set(bookId, {
        questions: parsedQuestions,
      });
    }
  });
  const promises: Promise<void>[] = Array.from(groupedQuestions.entries()).map(async ([bookId, body]) =>
    setBookTalkQuestions(bookId, body).catch((error) => {
      eventBus.$emit('snackbar.open', `Error while uploading questions for book ${bookId}: ${error}`);
    }),
  );

  await Promise.all(promises);
};

const uploadBookTalkDifficultWords = async (entries: any[]) => {
  const groupedWordsByBookId = new Map<string, SetBookTalkBody>();

  entries.forEach((entry) => {
    const bookId = entry[wordsSheetBookIdColumnHeader];
    const wordCell = entry[wordsSheetWordColumnHeader] as string;
    const wordDefinition = entry[wordsSheetDefinitionColumnHeader] as string;

    const parsedWords: DifficultWord[] = wordCell
      ? [
          {
            word: wordCell,
            definition: wordDefinition ?? undefined,
          },
        ]
      : [];

    if (groupedWordsByBookId.has(bookId)) {
      const bookWords = groupedWordsByBookId.get(bookId);
      if (bookWords) {
        bookWords.difficultWords = [...(bookWords.difficultWords || []), ...parsedWords];
      }
    } else {
      groupedWordsByBookId.set(bookId, {
        difficultWords: parsedWords,
      });
    }
  });
  const promises: Promise<void>[] = Array.from(groupedWordsByBookId.entries()).map(async ([bookId, body]) =>
    setBookTalkQuestions(bookId, body).catch((error) => {
      eventBus.$emit('snackbar.open', `Error while uploading words for book ${bookId}: ${error}`);
    }),
  );

  await Promise.all(promises);
};

const uploadBookTalkInstructions = async (entries: any[]) => {
  const instructionsByBookId = new Map<string, SetBookTalkBody>();

  entries.forEach((entry) => {
    const bookId = entry[instructionsSheetBookIdColumnHeader];
    const instructionsCell = entry[instructionsSheetInstructionsColumnHeader] as string;

    // TODO - double check this is correct when updating exercise types package version
    instructionsByBookId.set(bookId, {
      instructions: {
        text: instructionsCell,
      },
    });
  });
  const promises: Promise<void>[] = Array.from(instructionsByBookId.entries()).map(async ([bookId, body]) =>
    setBookTalkQuestions(bookId, body).catch((error) => {
      eventBus.$emit('snackbar.open', `Error while uploading instructions for book ${bookId}: ${error}`);
    }),
  );

  await Promise.all(promises);
};

return { __sfc: true,questionsSheetBookIdColumnHeader, questionsSheetPageStartColumnHeader, questionsSheetPageEndColumnHeader, questionsSheetQuestionColumnHeader, wordsSheetBookIdColumnHeader, wordsSheetWordColumnHeader, wordsSheetDefinitionColumnHeader, instructionsSheetBookIdColumnHeader, instructionsSheetInstructionsColumnHeader, uploadBookTalkQuestions, uploadBookTalkDifficultWords, uploadBookTalkInstructions, ImportButton }
}

})